import { render } from "./index.vue?vue&type=template&id=3ffbbd7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3ffbbd7a&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/omniapp.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__